import './theme/main.scss';

import debug from 'debug';
const log = debug('app:startup');

import './containers/common';
import './containers/user-management';
import './containers/upload-measurement';
import './containers/translations';
import "./containers/profiles-export";
import './config/modules';
import './config/dt-control-buttons';

import './components/datatable/buttons/excelExport';

import 'linksoft-datatables-fixedheader';
import 'linksoft-select2';
import 'linksoft-dropzone';
import 'linksoft-toastr';
import 'linksoft-sweetalert';

import { initialize, store, loadLocale } from 'linksoft';

import createStore from './config/store';
store.set(createStore());

// register all required initializers
import initializers from './config/initializers';
initialize.register(initializers);
import finalizers from './config/finalizers';
initialize.register(finalizers, true);

import customTemplates from './config/table-templates';
import customCallbacks from './config/table-callbacks';
import './config/table-renderers';
import ckeditorTemplates from './config/ck-editor-templates';

import Dropzone from 'dropzone';
// bear in mind that you have to change configuration also in FilesConfiguration in application project
Dropzone.options.acceptedFiles = ".pdf,.txt,.rtf,.doc,.docx,.dot,.dotx,.docm,.dotm,.xls,.xlt,.xlsx,.xlsm,.xltx,.csv,.ppt,.pps,.pot,.pptx,.pptm,.potx,.potm,.ppsx,.ppsm,.sldx,.sldm,.jpg,.jpeg,.bmp,.png,.xml,.xsd,.rar,.zip,.7z,.msg,.html,.htm,.p7s";

ckeditorTemplates(); //set templates for ck-editor

import $ from 'jquery';
// trigger first initialization on document ready
$(function () {
    loadLocale().then(() => {
        customTemplates();
        customCallbacks();
        initialize.trigger();
    });

    window.scrollUp = function () {
        log('scroll up');
        $('html, body').animate({ scrollTop: 0 }, 'slow');
    }
});

// trigger initializers on modal loaded
$(document).on('loaded.bs.modal', function (e) {
    initialize.trigger(e.target);
});
$(document).on('hidden.bs.modal', '[data-remote-content]', function (e) {
    $(e.target).removeData('bs.modal');
});



// WEBPACK FOOTER //
// ./App/startup.js